import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import moment from 'moment';
import { Observable, Subscription } from 'rxjs';
import { AuditNodeDto } from 'src/app/shared/models/swodoc/audit-node-dto.model';
import { AuditFormulaService } from 'src/app/shared/services/audit/audit-formula.service';

@Component({
  selector: 'swodoc-node-formula',
  templateUrl: 'swodoc-node-formula.html',
  styleUrls: ['swodoc-node-formula.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwodocNodeFormula implements OnInit, OnDestroy {
  @Input() node: AuditNodeDto;
  @Input() auditNodes: AuditNodeDto[];
  @Input() changer: Observable<string[] | void>;
  @Input() withEval: boolean;
  @Output() changed: EventEmitter<any> = new EventEmitter<any>();

  public value: string | number;
  public type = 'number';

  private _ngUnsubscribe = new Subscription();
  private _evalInProgress = false;

  constructor(private _auditFormulaProvider: AuditFormulaService, private _cdr: ChangeDetectorRef) {}

  async ngOnInit() {
    if (this.node?.options?.returnType && this.node.options.returnType !== 'number') {
      this.type = this.node.options.returnType;
    }

    this._ngUnsubscribe.add(
      this.changer.subscribe(async ids => {
        if (!ids || ids.includes(this.node.templateNodeId)) {
          await this.eval();
        }
      })
    );
    await this.eval();
  }

  ngOnDestroy() {
    this._ngUnsubscribe.unsubscribe();
  }

  private async eval() {
    if (!this._evalInProgress) {
      this._evalInProgress = true;
      try {
        if (this.node.selectables?.length > 0) {
          const value = await this._auditFormulaProvider.evalFormula(
            this.node.selectables,
            this.auditNodes,
            this.withEval
          );
          if (this.isValid(value) || value === 0) {
            this.value = this.type === 'time' ? moment(new Date(value)).format('HH:mm') : value;
            this._cdr.detectChanges();
            this.changed.emit({
              node: this.node,
              value: this.type === 'time' ? moment(new Date(value)).format() : this.value,
            });
          }
        }
      } finally {
        this._evalInProgress = false;
      }
    }
  }

  private isValid(value: string | number) {
    const isValueDefined = Boolean(value);
    const isValueObjectString = typeof value === 'string' && value.includes('[object Object]');
    return isValueDefined && !isValueObjectString;
  }
}
